import React, { useState, useEffect } from 'react';
import Canvas from './components/Canvas';
import Toolbar from './components/Toolbar';
import PropertyPanel from './components/PropertyPanel';
import useZoomPan from './hooks/useZoomPan';
import useSelection from './hooks/useSelection';
import useCollaboration from './hooks/useCollaboration';
import './styles/main.css';

const DiagramModule = ({ initialData, onSave, apiClient, theme = 'light' }) => {
  const [nodes, setNodes] = useState(initialData?.nodes || []);
  const [connectors, setConnectors] = useState(initialData?.connectors || []);
  const [selectedTool, setSelectedTool] = useState('select');
  const [selectedItems, setSelectedItems] = useState([]);
  
  const { zoom, pan, handleZoom, handlePanStart, handlePan } = useZoomPan();
  const { handleSelect, handleDragStart, handleDrag } = useSelection(nodes, setNodes, selectedItems, setSelectedItems);
  const { collaborators } = useCollaboration(apiClient, nodes, connectors);
  
  // Autoguardado cada 30 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      onSave({ nodes, connectors });
    }, 30000);
    return () => clearInterval(interval);
  }, [nodes, connectors, onSave]);
  
  return (
    <div className={`diagram-module page-content ${theme}`}>
      <Toolbar selectedTool={selectedTool} onToolSelect={setSelectedTool} />
      <Canvas
        nodes={nodes}
        connectors={connectors}
        zoom={zoom}
        pan={pan}
        onZoom={handleZoom}
        onPanStart={handlePanStart}
        onPan={handlePan}
        onSelect={handleSelect}
        onDragStart={handleDragStart}
        onDrag={handleDrag}
        selectedItems={selectedItems}
        collaborators={collaborators}
        selectedTool={selectedTool}
        setNodes={setNodes}
      />
      <PropertyPanel selectedItems={selectedItems} nodes={nodes} onUpdateItems={setNodes} />
    </div>
  );
};

export default DiagramModule;